import { render, staticRenderFns } from "./btn-language.vue?vue&type=template&id=dc0b6a52&scoped=true"
import script from "./btn-language.vue?vue&type=script&lang=js"
export * from "./btn-language.vue?vue&type=script&lang=js"
import style0 from "./btn-language.vue?vue&type=style&index=0&id=dc0b6a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0b6a52",
  null
  
)

export default component.exports